import { render, staticRenderFns } from "./TierConfigForm.vue?vue&type=template&id=45ec4ac8"
import script from "./TierConfigForm.vue?vue&type=script&lang=js"
export * from "./TierConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports